
import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-3">Introduction</h2>
          <p>
            At Habilou, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our habit tracking application. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the application.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Information We Collect</h2>
          <p className="mb-3">We may collect information about you in various ways, including:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Personal Data: Email address, password (encrypted), and usage data.</li>
            <li>Habit Data: Information about your habits, goals, and progress that you choose to track in our application.</li>
            <li>Usage Data: Information on how you use the application, including pages visited, features used, and time spent.</li>
            <li>Cookies and Tracking: We may use cookies and similar tracking technologies to track activity on our application.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">How We Use Your Information</h2>
          <p className="mb-3">We may use the information we collect about you for various purposes:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide and maintain our application</li>
            <li>To notify you about changes to our application</li>
            <li>To allow you to participate in interactive features of our application</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information so that we can improve our application</li>
            <li>To monitor the usage of our application</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Disclosure of Your Information</h2>
          <p className="mb-3">We may share your information with:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Service Providers: We may employ third-party companies to facilitate our application and provide services on our behalf.</li>
            <li>Analytics: We may use third-party analytics providers to analyze how users use our application.</li>
            <li>Legal Requirements: We may disclose your information where required to do so by law or in response to valid legal requests.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Security of Your Data</h2>
          <p>
            The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal data, we cannot guarantee its absolute security.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at privacy@habilou.com.
          </p>
        </section>
      </div>
      
      <div className="mt-8">
        <Link to="/" className="text-primary hover:underline">
          &larr; Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
